import React, { useState, useEffect } from 'react';
import { FaFolder, FaFolderOpen } from 'react-icons/fa';
import { AiFillDatabase } from 'react-icons/ai';
import defaultAxios from 'axios';
import { UseAxios } from '../common/useAxios';
import { SubSideBar } from './subSidBar';
import { SubSideBar2 } from './subSidBar2';
import { MainDisplay } from './mainDisplay';
import { backendUrl } from '../common/constantVarialble';

interface Node {
    code: string;
    p_code: string;
    depth: number;
}

interface NodeIconProps {
    isOpen: boolean;
    depth: number;
    code: string;
    toggleMenu: () => void;
    setProgramIDList: React.Dispatch<React.SetStateAction<any>>;
    setSelectedId: React.Dispatch<React.SetStateAction<any>>;
    selectedID: string;
    setProgramDepthParent: React.Dispatch<React.SetStateAction<any>>;
}

interface ProgramType {
    program_id: string;
    code: string;
    prg_description: string;
    depth: number;
    last_update_psn: string;
    last_update_dte: string;
    input_psn: string;
    input_dte: string;
}

interface ProgramDepthParent {
    depth: string;
    p_code: string;
}

interface ProgramArr {
    data: ProgramType[] | null;
}

interface ProgramMenuTreeViewProps {
    data: Node[] | null;
    setProgramIDList: React.Dispatch<React.SetStateAction<any>>;
}

const getProgramList = async (pCode: string) => {
    try {
        const { data } = await defaultAxios({
            method: 'post',
            //url: 'http://localhost:5000/api/request/',
            url: backendUrl,
            data: {
                program_id: 'PERCENT-ADMIN-PRG-L-LSTPROGRAMIDBYPARENTCODE',
                params: {
                    'p_code': pCode,
                },
                page_index: -1,
            },
        });

        return data;
    } catch (error) {
        console.error(error);
        return null;
    }
};


const MenuIcon: React.FC<NodeIconProps> = ({ isOpen, depth, code, toggleMenu, setProgramIDList, setSelectedId, selectedID, setProgramDepthParent }) => {

    const handleMenuClick = async () => {
        console.log("code", code);
        console.log("depth", depth);
        if (depth === 3) {
            const data = await getProgramList(code);
            if (data) {
                setProgramIDList(data.data);
                setSelectedId(code);
            }
            setProgramDepthParent({
                code: code,
                p_code: code,
                depth: depth
            });
        } else {
            setProgramIDList([]);
            toggleMenu();
            setProgramDepthParent(null);
        }
    };

    useEffect(() => {
        console.log("Created");
    }, [selectedID]);

    return (
        <div className={`flex items-center cursor-pointer my-2`} onClick={handleMenuClick}>
            {depth === 3 ? (
                <AiFillDatabase className={`${selectedID === code ? "text-orange-300" : "text-white"}`} />
            ) : isOpen ? (
                <FaFolderOpen className="text-white mr-2" />
            ) : (
                <FaFolder className="text-white mr-2" />
            )}
            <span className={`text-body ${selectedID === code && depth === 3 ? "text-orange-300" : "text-white"}`}>{code}</span>
        </div>
    );
};

function ProgramNode({
    node,
    programTreeList,
    setProgramIDList,
    selectedID,
    setSelectedId,
    setProgramDepthParent }:
    {
        node: Node,
        programTreeList: Node[],
        setProgramIDList: React.Dispatch<React.SetStateAction<any>>,
        selectedID: string,
        setSelectedId: React.Dispatch<React.SetStateAction<any>>,
        setProgramDepthParent: React.Dispatch<React.SetStateAction<any>>
    }) {
    const [menuOpen, setMenuOpen] = useState(false);

    const handleToggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <div className="ml-2">
            <MenuIcon
                isOpen={menuOpen}
                depth={node.depth}
                code={node.code}
                toggleMenu={handleToggleMenu}
                setProgramIDList={setProgramIDList}
                setSelectedId={setSelectedId}
                selectedID={selectedID}
                setProgramDepthParent={setProgramDepthParent}
            />
            {menuOpen && programTreeList ? (
                <ul>
                    {programTreeList
                        .filter((item) => item.p_code === node.code)
                        .map((childNode) => (
                            <li key={childNode.code}>
                                <ProgramNode
                                    node={childNode}
                                    programTreeList={programTreeList}
                                    selectedID={selectedID}
                                    setProgramIDList={setProgramIDList}
                                    setSelectedId={setSelectedId}
                                    setProgramDepthParent={setProgramDepthParent}
                                />
                            </li>
                        ))}
                </ul>
            ) : null}
        </div>
    );
}

function ProgramMenuTreeView2({
    sidebarOpen,
    setSidebarOpen,
    programIDList,
    setProgramIDList,
    setProgramDepthParent
}:
    {
        sidebarOpen: boolean,
        setSidebarOpen: React.Dispatch<React.SetStateAction<any>>,
        programIDList: any,
        setProgramIDList: React.Dispatch<React.SetStateAction<any>>
        setProgramDepthParent: React.Dispatch<React.SetStateAction<any>>
    }) {
    const [selectedID, setSelectedId] = useState("");
    //const [programIDList, setProgramIDList] = useState([]);
    const { loading, data, error, refetch } = UseAxios({
        method: 'post',
        //url: 'http://localhost:5000/api/request/',
        url: backendUrl,
        data: {
            "program_id": "PERCENT-ADMIN-PRG-L-LSTMENUTREE",
            "params": {},
            "page_index": -1
        }
    });

    const programTreeList: Node[] | null = data?.data.data;

    if (!programTreeList) {
        return (<div className="flex flex-row flex-1 text-white">

            Loading...

        </div>)
    }

    console.log("ProgramTreeList");
    console.log(programTreeList);

    const rootNodes = programTreeList.filter((node) => node.depth === 1);

    return (


        <div className='flex'>
            {rootNodes.map((node) => (
                <ProgramNode
                    key={node.code}
                    node={node}
                    programTreeList={programTreeList}
                    setProgramIDList={setProgramIDList}
                    selectedID={selectedID}
                    setSelectedId={setSelectedId}
                    setProgramDepthParent={setProgramDepthParent}
                />
            ))}
        </div>


    );
}

export default ProgramMenuTreeView2;




/*

        <div className="flex flex-row flex-1">
            <SubSideBar2 sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}>
                <div>
                    {rootNodes.map((node) => (
                        <ProgramNode
                            key={node.code}
                            node={node}
                            programTreeList={programTreeList}
                            setProgramIDList={setProgramIDList}
                            selectedID={selectedID}
                            setSelectedId={setSelectedId}
                        />
                    ))}
                </div>
            </SubSideBar2>
            <MainDisplay data={programIDList} />
        </div>
*/